const expandoBtn = document.querySelector('.js-stage-expando-btn');

function toggleStageExpando() {
  const isExpanded = expandoBtn.getAttribute('aria-expanded') === 'true';
  expandoBtn.setAttribute('aria-expanded', `${!isExpanded}`);
}

function init() {
  if (!expandoBtn) {
    return;
  }

  expandoBtn.addEventListener('click', toggleStageExpando);
}

export default init;
